import styled from 'styled-components';

export const MpOl = styled(`ol`)`
	gap: 24px;
	display: flex;
	flex-direction: column;
	padding-left: 16px;
`;
